export enum SchoolStatus {
  ALL = 0, // Alle
  ACTIVATE = 1, // Aktive
  DEACTIVATE = 2, // Deaktiverte
}
